import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { Button } from '../Button/index.js';

var FieldDisplay = function FieldDisplay(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      hideColon = props.hideColon,
      inline = props.inline,
      label = props.label,
      spacer = props.spacer,
      tooltipText = props.tooltipText,
      value = props.value;
  var classes = "".concat(className, " field-display ").concat(spacer ? 'spacer' : '');

  if (inline) {
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes, " inline")
    }, /*#__PURE__*/React.createElement("span", {
      className: "field-display-label"
    }, label, hideColon ? '' : ':'), ' ', /*#__PURE__*/React.createElement("span", {
      className: "field-display-value"
    }, value));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes, " not-inline")
  }, /*#__PURE__*/React.createElement("div", {
    className: "field-display-label"
  }, label, !!tooltipText && /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Popover, null, /*#__PURE__*/React.createElement(Popover.Body, null, tooltipText))
  }, /*#__PURE__*/React.createElement(Button, {
    className: "info m-l-5",
    style: "link",
    icon: "circle-info"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "field-display-value"
  }, value));
};

FieldDisplay.displayName = "FieldDisplay";
export { FieldDisplay };